import React from 'react';

interface ClientAvatarProps {
  name: string;
  logo?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

export const ClientAvatar: React.FC<ClientAvatarProps> = ({
  name,
  logo,
  size = 'md',
}) => {
  const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-16 w-16 text-lg',
  };

  const getInitials = (name: string): string => {
    const words = name.trim().split(' ').filter(Boolean);
    if (words.length === 0) return '';
    if (words.length === 1) {
      return (words[0] || '').substring(0, 2).toUpperCase();
    }
    return words
      .slice(0, 2)
      .map((word) => word?.[0] || '')
      .join('')
      .toUpperCase();
  };

  if (logo) {
    return (
      <img
        src={logo}
        alt={`${name} logo`}
        className={`${sizeClasses[size]} rounded-lg object-contain bg-gray-50`}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center font-semibold`}
    >
      {getInitials(name)}
    </div>
  );
};
